"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var services_1 = require("@nw/ui-core-shared/services");
var core_2 = require("@ngx-translate/core");
var Observable_1 = require("rxjs/Observable");
var dealerblock_best_offer_service_1 = require("../../../shared/services/dealerblock-best-offer.service");
var main_store_service_1 = require("@nw/ui-core-shared/store/main-store.service");
var modal_dialog_service_1 = require("@nw/ui-core-shared/services/modal-dialog.service");
var DealerblockAcceptCounterOfferV1Component = (function () {
    function DealerblockAcceptCounterOfferV1Component(modalDialogService, dealerblockBestOfferService, environmentService, mainStoreService, translateService) {
        this.modalDialogService = modalDialogService;
        this.dealerblockBestOfferService = dealerblockBestOfferService;
        this.environmentService = environmentService;
        this.mainStoreService = mainStoreService;
        this.translateService = translateService;
        this.acceptOfferHandler = new core_1.EventEmitter();
        this.confirmationHandler = new core_1.EventEmitter();
        this.sucessConfirmationHandler = new core_1.EventEmitter();
        this.ssoToken = '';
        this.lang = '';
    }
    DealerblockAcceptCounterOfferV1Component.prototype.ngOnInit = function () {
        var _this = this;
        this.acceptOfferImolaUrl = this.environmentService.getEnvironment().imola.acceptOffer;
        this.mainStoreService.getStore().select(function (state) { return state; }).subscribe(function (appMainState) {
            _this.classicRuntimeData = appMainState.appPrincipal.getClassicRuntimeData();
            if (appMainState.appPrincipal) {
                _this.ssoToken = appMainState.appPrincipal.ssoToken;
                _this.lang = appMainState.appPrincipal.language;
            }
        });
        this.sucessConfirmationHandler.subscribe(function () {
            _this.modalDialogService.hideModal();
            _this.acceptOfferHandler.emit();
        });
        this.confirmationHandler.subscribe(function () {
            _this.modalDialogService.showLoadingModal(true);
            _this.callImolaAPIMethod();
        });
    };
    DealerblockAcceptCounterOfferV1Component.prototype.showAcceptConfirmation = function () {
        this.prepareConfirmation(this.translateService.instant('dealerBlockLayout.acceptOfferConfirmation.title'), this.translateService.instant('dealerBlockLayout.acceptOfferConfirmation.message'), true, true, this.translateService.instant('dealerBlockLayout.acceptOffer'), this.translateService.instant('dealerBlockLayout.cancel'), this.confirmationHandler);
    };
    DealerblockAcceptCounterOfferV1Component.prototype.callImolaAPIMethod = function () {
        var _this = this;
        Observable_1.Observable.from(this.dealerblockBestOfferService.acceptDeclientImolaServiceCall(this.originBestOfferId, this.boOriginOrgId, this.classicRuntimeData.conversationId, this.ssoToken, this.acceptOfferImolaUrl))
            .subscribe(function (res) {
            var errorCode = res.data.status;
            if (errorCode === 'SUCCESS') {
                _this.prepareConfirmation(_this.translateService.instant('dealerBlockLayout.acceptOfferConfirmation.title'), _this.translateService.instant('dealerBlockLayout.acceptOfferConfirmation.acceptedMessage'), true, false, _this.translateService.instant('dealerBlockLayout.ok'), null, _this.sucessConfirmationHandler);
            }
            else {
                var error_1;
                _this.translateService.get("acceptDeclineImolaError." + errorCode).map(function (translate) {
                    return translate['errorMessage'];
                }).subscribe(function (errorMsg) {
                    error_1 = errorMsg ? errorMsg : res.data.status + ": " + res.data.emsg;
                });
                _this.prepareConfirmation(_this.translateService.instant('acceptDeclineImolaError.title'), error_1, true, false, _this.translateService.instant('dealerBlockLayout.ok'), null, null);
            }
        }, function (err) {
            _this.prepareConfirmation(_this.translateService.instant('acceptDeclineImolaError.title'), err.message, true, false, _this.translateService.instant('dealerBlockLayout.ok'), null, null);
        });
    };
    DealerblockAcceptCounterOfferV1Component.prototype.prepareConfirmation = function (title$, message$, showOk$, showCancel$, okContent$, cancelContent$, okEventHandler$) {
        this.modalDialogService.showLoadingModal(false);
        this.modalDialogService.hideModal();
        var confirmation = {
            title: title$,
            message: message$,
            showOK: showOk$,
            okContent: okContent$,
            okEventHandler: okEventHandler$,
            showCancel: showCancel$,
            cancelContent: cancelContent$
        };
        this.modalDialogService.showModal(confirmation);
    };
    DealerblockAcceptCounterOfferV1Component.prototype.ngOnDestroy = function () {
        this.confirmationHandler.unsubscribe();
        this.sucessConfirmationHandler.unsubscribe();
    };
    return DealerblockAcceptCounterOfferV1Component;
}());
DealerblockAcceptCounterOfferV1Component.decorators = [
    { type: core_1.Component, args: [{
                selector: 'nw-dealerblock-accept-counter-offer-v1',
                template: "<div *ngIf=\"isBoCounteredPlaced\">\n  <button class=\"btn btn-block db-best-offer-btn wrap-content\" data-a8n=\"db-accept-counter-offer\" (click)=\"showAcceptConfirmation()\">\n     {{'dealerBlockLayout.acceptOffer' | translate }} {{ boCounteredAmount | nwCurrency: lang }}</button>\n</div>",
                styles: [""]
            },] },
];
/** @nocollapse */
DealerblockAcceptCounterOfferV1Component.ctorParameters = function () { return [
    { type: modal_dialog_service_1.ModalDialogService, },
    { type: dealerblock_best_offer_service_1.DealerblockBestOfferService, },
    { type: services_1.EnvironmentService, },
    { type: main_store_service_1.MainStoreService, },
    { type: core_2.TranslateService, },
]; };
DealerblockAcceptCounterOfferV1Component.propDecorators = {
    'isBoCounteredPlaced': [{ type: core_1.Input },],
    'boCounteredAmount': [{ type: core_1.Input },],
    'originBestOfferId': [{ type: core_1.Input },],
    'boOriginOrgId': [{ type: core_1.Input },],
    'acceptOfferHandler': [{ type: core_1.Output },],
};
exports.DealerblockAcceptCounterOfferV1Component = DealerblockAcceptCounterOfferV1Component;
//# sourceMappingURL=dealerblock-accept-counter-offer-v1.component.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nw/dealerblock-bid-ui/components/components-v1/dealerblock-accept-counter-offer-v1/dealerblock-accept-counter-offer-v1.component.js
// module id = 2OQK
// module chunks = 0